import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";

enum AnswerOption{
	KEEP = "keepOcclusalHeight",
	FIRST_CONTACT = "firstContact",
	FIRST_CONTACT_AND_LOWER = "firstContactAndLower",
	LOWER_UNTIL = "lowerUntil",
	LOWER_BY_MM = "lowerBy",
	LIFT_BY_MM = "liftBy"
}

@Component({
	selector: "occlusal-height-form",
	standalone: true,
	imports: [
		CommonModule,
		MatRadioModule,
		MatInputModule,
		TranslateModule,
		ReactiveFormsModule
	],
	templateUrl: "./occlusalHeightForm.component.html",
	styleUrl: "./occlusalHeightForm.component.scss"
})
export class OcclusalHeightFormComponent implements OnInit {
	@Input() parentForm: FormGroup;
	nestedFormGroupName = "occlusalHeightInstruction";

	AnswerOption = AnswerOption;

	answersWithText = [
		AnswerOption.FIRST_CONTACT_AND_LOWER,
		AnswerOption.LOWER_UNTIL,
		AnswerOption.LOWER_BY_MM,
		AnswerOption.LIFT_BY_MM
	];

	optionFormControl: FormControl;
	textFormControl: FormControl;

	ngOnInit(): void {
		this.optionFormControl = this.parentForm.get(`${this.nestedFormGroupName}.option`) as FormControl;
		this.textFormControl = this.parentForm.get(`${this.nestedFormGroupName}.text`) as FormControl;

		//set en-/disabled state depending on value (e.g. should not be disabled when form is prefilled)
		if(this.textFormControl.value){
			this.textFormControl.enable({emitEvent: false});
		}else{
			this.textFormControl.disable({emitEvent: false});
		}

		this.optionFormControl?.valueChanges.subscribe((value) => {
			if (this.answersWithText.includes(value)) {
				this.textFormControl?.enable({ emitEvent: false });
				this.textFormControl?.setValidators([Validators.required]);
				this.textFormControl?.markAsTouched();
			} else {
				this.textFormControl?.patchValue(null, { emitEvent: false });
				this.textFormControl?.disable({ emitEvent: false });
				this.textFormControl?.clearValidators();
			}
			this.textFormControl?.updateValueAndValidity();
		});
	}
}
